//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
// import { axiosPost } from '../../axios/axios.js'
import Table from '../../components/Table/Table.vue'
import { EventBus } from '../../EventBus/EventBus'
export default {
  components: {
    Table
  },
  props: {
    config: {
      type: Object,
      default: null
    },
    objectSrc: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      accessedWorkAreas: [],
      dataControl: null,
      columns: [
        {
          name: 'name',
          label: 'Направление работ',
          align: 'left',
          field: row => row.name,
          sort: (a, b, rowA, rowB) => rowA.name > rowB.name ? 1 : -1,
          sortable: true
        }
      ],
      changesEmployeeControl: [],
      selectedItemsIds: []
    }
  },
  computed: {
    ...mapGetters({
      workAreas: 'getWorkAreas'
    })
  },
  watch: {
    /* 'objectSrc.id': {
      handler: function (data) {
        this.setDocumentsAccessedWorkAreas()
      },
      immediate: true
    }, */
    'objectSrc.documentsAccessedWorkAreas': {
      handler: function (data) {
        const newAccessed = data.length > 0 ? JSON.parse(JSON.stringify(data)).sort((previos, next) => previos > next ? 1 : -1) : []
        const selected = this.selectedItemsIds.length > 0 ? JSON.parse(JSON.stringify(this.selectedItemsIds)).sort((previos, next) => previos > next ? 1 : -1) : []
        if (JSON.stringify(newAccessed) !== JSON.stringify(selected)) {
          this.selectedItemsIds = newAccessed
          this.setDocumentsAccessedWorkAreas()
        }
        //
      },
      immediate: true
    },
    'objectInitial.documentsAccessedWorkAreas': {
      handler: function (data) {
        this.setDocumentsAccessedWorkAreas()
      },
      immediate: true
    },
    changesEmployeeControl: {
      handler: function (data) {
        this.$set(this.objectSrc, 'amountControl', data.length)
        EventBus.$emit('update-amount-control', 'accessedDocumentsWorkAreas', data.length)
      },
      immediate: true
    }
  },
  methods: {
    setDocumentsAccessedWorkAreas: function () {
      const accessed = this.objectSrc.documentsAccessedWorkAreas || []
      const accessedInitial = this.objectInitial.documentsAccessedWorkAreas || []
      this.selectedItemsIds = accessed
      this.workAreas.map(item => {
        const _accessInderx = this.accessedWorkAreas.length > 0 ? this.accessedWorkAreas.findIndex(element => element.key == item.key) : -1
        if (_accessInderx < 0) {
          this.accessedWorkAreas.push({
            key: item.key,
            name: item.name,
            access: accessed.length > 0 && accessed.includes(item.key),
            oldAccess: accessedInitial.length > 0 && accessedInitial.includes(item.key)
          })
        } else {
          this.$set(this.accessedWorkAreas[_accessInderx], 'access', accessed.length > 0 && accessed.includes(item.key))
          this.$set(this.accessedWorkAreas[_accessInderx], 'oldAccess', accessedInitial.length > 0 && accessedInitial.includes(item.key))
        }
        return item
      })
      this.changesEmployeeControl = this.accessedWorkAreas.filter(item => item.access !== item.oldAccess).map(item => item.key)
    },
    /* onSaveAccessControlEmployees: function (data) {
      const urlName = '/service/delta/employee/setdocumentaccess'
      const bodyFormData = new FormData()
      if (!this.changesEmployeeControl.length) {
        this.onCanselAccessControlEmployee()
        return false
      }
      const accessedKeys = this.accessedWorkAreas.filter(item => item.access).map(item => item.key)
      const _data = [{ employeeId: this.objectSrc.id, accessedWorkAreas: (accessedKeys.length > 0 ? accessedKeys : null) }]
      bodyFormData.set('data', JSON.stringify(_data))
      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Доступ успешно изменен!',
            progress: true,
            timeout: 3000
          })
          this.$nextTick(() => {
            this.accessedWorkAreas.map(item => {
              item.oldAccess = item.access
              return item
            })
            this.changesEmployeeControl = []
          })
        },
        onFailure: (response) => {
          const mes = response.message ? response.message : 'Ошибка изменения доступа!'
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
        },
        msgTarget: this
      })
    },
    onCanselAccessControlEmployee: function () {
      this.accessedWorkAreas.map(item => {
        if (item.access !== item.oldAccess) {
          this.$set(item, 'access', item.oldAccess)
          const _index = this.selectedItemsIds.findIndex(element => element == item.key)
          if (_index > -1 && !item.oldAccess) {
            this.selectedItemsIds.splice(_index, 1)
          } else if (_index == -1 && item.oldAccess) {
            this.selectedItemsIds.push(item.key)
          }
        }
        return item
      })
      this.changesEmployeeControl = []
    }, */
    onSelectItem: function (item) {
      this.$set(item, 'access', item.isChecked)
      const _index = this.selectedItemsIds.findIndex(element => element == item.key)
      if (item.isChecked && _index == -1) {
        this.selectedItemsIds.push(item.key)
      } else if (!item.isChecked && _index > -1) {
        this.selectedItemsIds.splice(_index, 1)
      }
      const accessIndex = this.changesEmployeeControl.findIndex(element => element == item.key)
      if ((item.access !== item.oldAccess) && accessIndex == -1) {
        this.changesEmployeeControl.push(item.key)
      } else if ((item.access == item.oldAccess) && accessIndex > -1) {
        this.changesEmployeeControl.splice(accessIndex, 1)
      }
    },
    getClassRow: function (row) {
      return (row.access !== row.oldAccess ? 'bg-pink-1' : (row.isChecked ? 'bg-blue-1' : 'bg-white'))
    },
    onSelectAllItems: function (isChecked) {
      this.accessedWorkAreas.map(item => {
        this.$set(item, 'access', isChecked)
        const accessIndex = this.changesEmployeeControl.findIndex(element => element == item.key)
        const selectIndex = this.selectedItemsIds.findIndex(element => element == item.key)
        if ((item.access !== item.oldAccess) && accessIndex == -1) {
          this.changesEmployeeControl.push(item.key)
        } else if ((item.access == item.oldAccess) && accessIndex > -1) {
          this.changesEmployeeControl.splice(accessIndex, 1)
        }
        if (isChecked && selectIndex == -1) {
          this.selectedItemsIds.push(item.key)
        } else if (!isChecked && selectIndex > -1) {
          this.selectedItemsIds.splice(selectIndex, 1)
        }
        return item
      })
    },
    setAreaWorkEmployee: function () {
      const employeeWorkArea = this.objectSrc.employeeWorkarea && this.objectSrc.employeeWorkarea.length > 0 ? this.objectSrc.employeeWorkarea.map(element => element.key) : []
      this.onSelectAllItems(false)
      this.accessedWorkAreas.filter(item => employeeWorkArea.includes(item.key)).map(item => {
        item.isChecked = true
        this.onSelectItem(item)
        return item
      })
    }
  }
}
